import { SelectOption } from '@web-for-marketing/react-ui';

const titleOptions: SelectOption[] = [
    { content: 'Driver', value: 'Driver' },
    { content: 'Fleet Manager', value: 'Fleet Manager' },
    { content: 'Operations Manager', value: 'Operations Manager' },
    { content: 'Compliance/Safety Manager', value: 'Compliance/Safety Manager' },
    { content: 'Sr. Management', value: 'Sr. Management' },
    { content: 'C-Level', value: 'C-Level' },
    { content: 'Data Analyst', value: 'Data Analyst' },
    { content: 'Vendor/Procurement Manager', value: 'Vendor/Procurement Manager' },
    { content: 'Other', value: 'Other' },
];

export default titleOptions;
